import { SharePointListClient, type ListItem } from '../SharePointListClient';

/** 99.ABM_PercepcionImpuesto — catalogue of percepción / impuesto names. */
export type PercepcionImpuestoFields = {
  Title?: string | null;
  PercepcionImpuesto_PI?: string | null;
  Status_PI?: 'Activo' | 'Inactivo' | string | null;
};

export type PercepcionImpuestoItem = ListItem<PercepcionImpuestoFields>;

export const percepcionesImpuestoClient = new SharePointListClient<PercepcionImpuestoFields>(
  'ABM_PercepcionImpuesto',
);

export async function listAllPercepcionesImpuesto(): Promise<PercepcionImpuestoItem[]> {
  return percepcionesImpuestoClient.listItems({ top: 5000 });
}

export async function listActivePercepcionesImpuesto(): Promise<PercepcionImpuestoItem[]> {
  return percepcionesImpuestoClient.listItems({
    filter: "fields/Status_PI eq 'Activo'",
    orderBy: 'fields/PercepcionImpuesto_PI asc',
  });
}

export async function createPercepcionImpuesto(nombre: string): Promise<PercepcionImpuestoItem> {
  return percepcionesImpuestoClient.createItem({
    Title: '[sumar]',
    PercepcionImpuesto_PI: nombre.trim(),
    Status_PI: 'Activo',
  });
}

export async function updatePercepcionImpuesto(
  id: string,
  nombre: string,
): Promise<PercepcionImpuestoItem> {
  return percepcionesImpuestoClient.updateItem(id, { PercepcionImpuesto_PI: nombre.trim() });
}

export async function softDeletePercepcionImpuesto(id: string): Promise<PercepcionImpuestoItem> {
  return percepcionesImpuestoClient.updateItem(id, { Status_PI: 'Inactivo' });
}
